import { useState } from 'react';
import { Modal, Image, Button } from 'react-bootstrap';
import ImageViewerModal from './ImageViewerModal';
import ImageWithFooter from './ImageWithFooter';

const ViewActivityModal = ({ show, activity, onClose }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const formatGeolocation = (geo) => {
    if (!geo) return 'N/A';
    try {
      const parsed = JSON.parse(geo);
      return `Lat: ${parsed.latitude}, Long: ${parsed.longitude}`;
    } catch {
      return geo;
    }
  };

  const handleImageClick = (imageSrc, footer) => {
    setSelectedImage({ src: imageSrc, footer });
    setShowImageModal(true);
  };

  return (
    <>
      <Modal show={show} onHide={onClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Activity Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activity && (
            <div className="activity-details">
              <div className="mb-3">
                <h5>User: {activity.user.firstName} {activity.user.lastName}</h5>
              </div>
              
              <div className="row mb-3">
                <div className="col-md-6">
                  <h6>Check-in</h6>
                  <p>Time: {new Date(activity.checkInAt).toLocaleString()}</p>
                  <p>Selfie:</p>
                  {activity.checkInSelfie && activity.checkInSelfie !== 'N/A' && (
                    <div 
                        className="image-container"
                        onClick={() => handleImageClick(activity.checkInSelfie, activity.checkInGeolocation)}
                        style={{ cursor: 'pointer' }}
                    >
                      <ImageWithFooter
                        src={activity.checkInSelfie} 
                        footer={activity.checkInGeolocation}
                        alt="Check-out selfie" 
                        fluid
                        rounded
                        thumbnail
                      />
                    </div>
                  )}
                  <br></br>
                  <p>Store Front:</p>
                  {activity.checkInStoreFront && activity.checkInStoreFront !== 'N/A' && (
                    <div 
                        className="image-container"
                        onClick={() => handleImageClick(activity.checkInStoreFront, activity.checkInGeolocation)}
                        style={{ cursor: 'pointer' }}
                    >
                      <ImageWithFooter
                        src={activity.checkInStoreFront} 
                        footer={activity.checkInGeolocation}
                        alt="Check-out selfie" 
                        fluid
                        rounded
                        thumbnail
                      />
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <h6>Check-out</h6>
                  <p>Time: {activity.checkOutAt ? new Date(activity.checkOutAt).toLocaleString() : null}</p>
                  <p>Selfie:</p>
                  {activity.checkOutSelfie && activity.checkOutSelfie !== 'N/A' && (
                    <div 
                        className="image-container"
                        onClick={() => handleImageClick(activity.checkOutSelfie, activity.checkOutGeolocation)}
                        style={{ cursor: 'pointer' }}
                    >
                      <ImageWithFooter
                        src={activity.checkOutSelfie} 
                        footer={activity.checkOutGeolocation}
                        alt="Check-out selfie" 
                        fluid
                        rounded
                        thumbnail
                      />
                    </div>
                  )}
                  <br></br>
                  <p>Store Front:</p>
                  {activity.checkOutStoreFront && activity.checkOutStoreFront !== 'N/A' && (
                    <div 
                        className="image-container"
                        onClick={() => handleImageClick(activity.checkOutStoreFront, activity.checkOutGeolocation)}
                        style={{ cursor: 'pointer' }}
                    >
                      <ImageWithFooter
                        src={activity.checkOutStoreFront} 
                        footer={activity.checkOutGeolocation}
                        alt="Check-out selfie" 
                        fluid
                        rounded
                        thumbnail
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <ImageViewerModal
        show={showImageModal}
        imageUrl={selectedImage?.src}
        footer={selectedImage?.footer}
        onClose={() => setShowImageModal(false)}
      />
    </>
  );
};

export default ViewActivityModal;